import React from 'react';
import PropTypes from 'prop-types';
import { combineReducers, createStore } from 'redux';
import { handleActions } from 'redux-actions';
import { Provider as ReactReduxProvider } from 'react-redux';
import CAROUSEL_DATA from './data/carousel';

const error = handleActions({}, null);
const loading = handleActions({}, false);
const rootReducer = combineReducers({
    error,
    loading,
    carousel: combineReducers({
        loading: handleActions({}, true),
        slides: handleActions({}, []),
    }),
});

const store = createStore(
    combineReducers({
        MyIcsc: rootReducer,
    })
);

const Provider = ({ children }) => <ReactReduxProvider store={store}>{children}</ReactReduxProvider>;

Provider.propTypes = {
    children: PropTypes.any,
};

export default Provider;
